import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/tracker';

const RouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        trackEvent('PAGE_VIEW', `Visited ${location.pathname}`);
    }, [location]);

    return null;
};

export default RouteTracker;
